import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'danger_outline' | 'link';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  ...props
}) => {
  const baseStyle = "font-semibold rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 transition duration-150 ease-in-out";
  
  let variantStyle = "";
  switch (variant) {
    case 'primary':
      variantStyle = "bg-[#b98e4c] hover:bg-[#a37d40] text-[#1a2c46] focus:ring-[#b98e4c]"; // Gold with dark text
      break;
    case 'secondary':
      variantStyle = "bg-gray-200 hover:bg-gray-300 text-[#1a2c46] focus:ring-gray-400";
      break;
    case 'danger':
      variantStyle = "bg-red-600 hover:bg-red-700 text-white focus:ring-red-500";
      break;
    case 'danger_outline':
      variantStyle = "bg-white text-red-600 border border-red-600 hover:bg-red-50 focus:ring-red-500";
      break;
    case 'link':
      variantStyle = "text-[#1a2c46] hover:text-[#b98e4c] underline focus:ring-[#b98e4c] shadow-none"; // Navy link, gold hover
      break;
  }

  let sizeStyle = "";
  switch (size) {
    case 'sm':
      sizeStyle = "py-1 px-3 text-sm";
      break;
    case 'md':
      sizeStyle = "py-2 px-4 text-base";
      break;
    case 'lg':
      sizeStyle = "py-3 px-6 text-lg";
      break;
  }
  
  return (
    <button
      className={`${baseStyle} ${variantStyle} ${sizeStyle} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};